import React, { useState } from 'react';
import { RefreshCw, ShieldCheck, WifiOff } from 'lucide-react';
import './Offline.css';

const Offline = () => {
    const [checking, setChecking] = useState(false);

    const retryConnection = () => {
        setChecking(true);
        window.setTimeout(() => {
            if (navigator.onLine) window.dispatchEvent(new Event('online'));
            else setChecking(false);
        }, 500);
    };

    return (
        <main className="offline-page">
            <div className="offline-page__glow offline-page__glow--one" />
            <div className="offline-page__glow offline-page__glow--two" />

            <section className="offline-card" aria-labelledby="offline-title">
                <div className="offline-card__icon" aria-hidden="true">
                    <WifiOff size={38} strokeWidth={1.8} />
                    <span />
                </div>

                <span className="offline-card__eyebrow"><ShieldCheck size={14} /> Admin console</span>
                <h1 id="offline-title">No internet connection</h1>
                <p>
                    We cannot connect right now. Check your Wi-Fi or mobile data,
                    then try again. Your current page is saved.
                </p>

                <button type="button" className="offline-card__retry" onClick={retryConnection} disabled={checking}>
                    <RefreshCw className={checking ? 'is-spinning' : ''} size={18} />
                    {checking ? 'Checking connection…' : 'Try again'}
                </button>

                <div className="offline-card__status">
                    <span /> Offline
                </div>
            </section>

            <footer className="offline-footer">Gettimelam Matrimony · Secure administration</footer>
        </main>
    );
};

export default Offline;
